import { GET_ALL_REGIONS_SUCCESS } from 'actions/regions/constants';

const initialState = [];

export const regionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_REGIONS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};
